import type { ReactNode } from "react";
import { ApprovalList } from "@/components/shared/ApprovalList/ApprovalList";
import { useApprovals } from "@/hooks/useApprovals";
import styles from "./MyApprovalsPage.module.scss";

export function MyApprovalsPage(): ReactNode {
  const { approvals, isLoading, error, actionInProgress, handleAction } = useApprovals();

  if (isLoading) {
    return (
      <div className={styles.loadingState} role="status" aria-label="Loading approvals">
        <div className={styles.spinner} />
        <p className={styles.loadingMessage}>Loading approvals...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorState} role="alert">
        <span>Failed to load approvals. Please try again later.</span>
      </div>
    );
  }

  return (
    <ApprovalList
      approvals={approvals}
      actionInProgress={actionInProgress}
      onAction={handleAction}
    />
  );
}
